<template>
  <basic-content>
    <a-row slot="content">
      <product />
    </a-row>
  </basic-content>
</template>

<script>
import BasicContent from '@/layout/BasicContent.vue'
import Product from '@/com/Product/Product.vue'

export default {
  name: 'ProductMain',
  data() {
    return {
      tab: 'pro'
    }
  },
  components: {
    BasicContent,
    Product
  },
  created() {
    this.$store.commit('changetab', this.tab)
  }
}
</script>

<style scoped>
</style>
